/**
 * Tutor portal RBAC (Spatie names) from tutor login / GET tutor/auth/permissions.
 * If `tutor-permissions` is absent from localStorage, all checks pass (legacy until sync).
 */
export function getTutorPermissionsFromStorage() {
  try {
    if (localStorage.getItem("tutor-permissions") === null) {
      return null;
    }
    const raw = localStorage.getItem("tutor-permissions");
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function tutorHasPermission(permission) {
  if (!permission || typeof permission !== "string") return false;
  const list = getTutorPermissionsFromStorage();
  if (list === null) return true;
  return list.includes(permission);
}

export function tutorHasAllPermissions(permissions) {
  if (!Array.isArray(permissions) || permissions.length === 0) return false;
  const list = getTutorPermissionsFromStorage();
  if (list === null) return true;
  return permissions.every((p) => list.includes(p));
}

export function tutorHasAnyPermission(permissions) {
  if (!Array.isArray(permissions) || permissions.length === 0) return false;
  const list = getTutorPermissionsFromStorage();
  if (list === null) return true;
  return permissions.some((p) => list.includes(p));
}
